const STORAGE_KEY = 'tecdrive_admin_session';

export function saveSession(session) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
  // Compat con guard/legado que leía `token`
  if (session?.accessToken) {
    localStorage.setItem('token', session.accessToken);
  }
}

export function getSession() {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    localStorage.removeItem(STORAGE_KEY);
    return null;
  }
}

export function clearSession() {
  localStorage.removeItem(STORAGE_KEY);
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('refreshToken');
}

export function forceLogoutForInactiveAccount() {
  clearSession();
  const base = (process.env.BASE_URL || '/').replace(/\/$/, '');
  window.location.replace(`${base}/auth/login?inactive=1`);
}

export function getAccessToken() {
  const session = getSession();
  return session?.accessToken || localStorage.getItem('token') || null;
}

export function isAuthenticated() {
  return Boolean(getAccessToken());
}
